// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { FileCode as RawFileCode } from "lucide-react";
export const FileCode = /* @__PURE__ */ createIcon(RawFileCode, "FileCode", 2);
